export default {
  backendApi: "https://keycma-backend.testyourapp.online",
  // https://api.keycma.com
};
